module.exports = __webpack_public_path__ + "static/media/profile.e0c55edb.svg";